import _ from "lodash";
import { v4 as uuidv4 } from "uuid";

import { constructQueryParams, toTitleCase } from "@/common/validation/Validators";
import { Actions as DEPUTY_ACTIONS } from "@/integrations/deputy/store/deputyActions";
import { Actions as FYORIN_ACTIONS } from "@/integrations/fyorin/store/fyorinActions";
import { Actions as PEOPLES_PENSION_ACTIONS } from "@/integrations/peoplePension/store/peoplesPensionActions";
import { NotificationManager } from "react-notifications";
import { Actions as COMPANY_ACTIONS } from "./companyActions";
import { Actions as LEAVE_ACTIONS } from "./leaveActions";
import { Actions as NOTIFICATION_ACTIONS } from "./notificationActions";

import { createRequest } from "@/common/helpers/RequestHelpers";
import { checkExecutionStatus } from "@/components/common/helpers/RequestHelpers";
import { mapPensionsForDropdown, mapSalariesForDropdown, mapTaxesForDropdown } from "@/helpers/Remappers";
import axios from "axios";
import cleanDeep from "clean-deep";
import { addDays, addMonths, addYears, differenceInCalendarDays, format, parse, parseISO } from "date-fns";
import apiURL from "./apiURL";
// const apiURL = "http://localhost:3001";

const agreementRequest = createRequest({
	urlPath: "/settings/agreement/",
	// local: true,
});
const request = createRequest({
	urlPath: "/settings/",
	// local: true,
});

const Types = {
	EMPLOYEES_GET_LIST: "EMPLOYEES_GET_LIST",
	EMPLOYEES_IMPORT_PE_MODAL: "EMPLOYEES_IMPORT_PE_MODAL",
	EMPLOYEES_SHOW_INVITE_MODAL: "EMPLOYEES_SHOW_INVITE_MODAL",
	EMPLOYEES_INVITE_SENT_STATUS: "EMPLOYEES_INVITE_SENT_STATUS",
	EMPLOYEES_SINGLE_INVITE_SENDING_STATUS: "EMPLOYEES_SINGLE_INVITE_SENDING_STATUS",
	EMPLOYEES_UPDATE_LIST: "EMPLOYEES_UPDATE_LIST",
	EMPLOYEES_UPDATE_TERMINATED_LIST: "EMPLOYEES_UPDATE_TERMINATED_LIST",
	EMPLOYEES_UPDATE_LIST_WITH_SALARY: "EMPLOYEES_UPDATE_LIST_WITH_SALARY",
	EMPLOYEES_UPLOAD_TEMPLATE: "EMPLOYEES_UPLOAD_TEMPLATE",
	EMPLOYEES_FIELD_MAPPING: "EMPLOYEES_FIELD_MAPPING",
	EMPLOYEES_FIELD_UPDATE_MAPPING: "EMPLOYEES_FIELD_UPDATE_MAPPING",
	EMPLOYEES_FIELD_UPDATE_DEFAULT_MAPPING: "EMPLOYEES_FIELD_UPDATE_DEFAULT_MAPPING",
	EMPLOYEES_FIELD_UPDATE_INNER_MAPPING: "EMPLOYEES_FIELD_UPDATE_INNER_MAPPING",
	EMPLOYEES_UPLOADING: "EMPLOYEES_UPLOADING",
	EMPLOYEES_UPLOADED: "EMPLOYEES_UPLOADED",
	EMPLOYEES_IMPORT_MODAL: "EMPLOYEES_IMPORT_MODAL",
	EMPLOYEES_FILE_UPLOADING: "EMPLOYEES_FILE_UPLOADING",
	EMPLOYEES_FILE_UPLOADED: "EMPLOYEES_FILE_UPLOADED",
	EMPLOYEE_COLA_REQUIRED: "EMPLOYEE_COLA_REQUIRED",
	EMPLOYEE_COLA_PERIOD: "EMPLOYEE_COLA_PERIOD",
	EMPLOYEE_UNLINK_GRADE: "EMPLOYEE_UNLINK_GRADE",
	EMPLOYEE_APPLY_GRADE: "EMPLOYEE_APPLY_GRADE",
	EMPLOYEE_SAVING_EARNINGS: "EMPLOYEE_SAVING_EARNINGS",
	EMPLOYEE_PREVIOUS_EARNINGS: "EMPLOYEE_PREVIOUS_EARNINGS",
	EMPLOYEE_NOTES: "EMPLOYEE_NOTES",
	EMPLOYEE_AUDIT_LOGS: "EMPLOYEE_AUDIT_LOGS",
	EMPLOYEE_TAB: "EMPLOYEE_TAB",
	EMPLOYEE_DETAILS: "EMPLOYEE_DETAILS",
	EMPLOYEE_SAVED_DETAILS: "EMPLOYEE_SAVED_DETAILS",
	EMPLOYEE_SAVED_SALARY: "EMPLOYEE_SAVED_SALARY",
	EMPLOYEE_DELETE_SALARY_MODAL: "EMPLOYEE_DELETE_SALARY_MODAL",
	EMPLOYEE_DELETED_SALARY: "EMPLOYEE_DELETED_SALARY",
	EMPLOYEE_DELETING_SALARY: "EMPLOYEE_DELETING_SALARY",
	EMPLOYEE_DELETE_PENSION_MODAL: "EMPLOYEE_DELETE_PENSION_MODAL",
	EMPLOYEE_DELETING_PENSION: "EMPLOYEE_DELETING_PENSION",
	EMPLOYEE_SAVED_TAX: "EMPLOYEE_SAVED_TAX",
	EMPLOYEE_SAVING_BANK: "EMPLOYEE_SAVING_BANK",
	EMPLOYEE_SAVED_BANK: "EMPLOYEE_SAVED_BANK",
	EMPLOYEE_SAVED_TAX_CREDIT: "EMPLOYEE_SAVED_TAX_CREDIT",
	EMPLOYEE_SAVED_DEPARTMENT: "EMPLOYEE_SAVED_DEPARTMENT",
	EMPLOYEE_SAVED_TERMINATION: "EMPLOYEE_SAVED_TERMINATION",
	EMPLOYEE_CONFIRM_CHANGE_MODAL: "EMPLOYEE_CONFIRM_CHANGE_MODAL",
	EMPLOYEE_SAVING_CHANGE_MODAL: "EMPLOYEE_SAVING_CHANGE_MODAL",
	EMPLOYEE_SAVED_CHANGE_MODAL: "EMPLOYEE_SAVED_CHANGE_MODAL",
	EMPLOYEE_SAVED_PAY_BY_BANK: "EMPLOYEE_SAVED_PAY_BY_BANK",
	EMPLOYEE_TAX_OPTIONS: "EMPLOYEE_TAX_OPTIONS",
	EMPLOYEE_SAVING_ENGAGEMENT_DATE: "EMPLOYEE_SAVING_ENGAGEMENT_DATE",
	EMPLOYEE_UPDATED_ENGAGEMENT_DATE: "EMPLOYEE_UPDATED_ENGAGEMENT_DATE",
	EMPLOYEE_ENGAGEMENT_DATE_MODAL: "EMPLOYEE_ENGAGEMENT_DATE_MODAL",
	EMPLOYEE_TERMINATION_DATE_MODAL: "EMPLOYEE_TERMINATION_DATE_MODAL",
	EMPLOYEE_SAVING_TERMINATION_DATE: "EMPLOYEE_SAVING_TERMINATION_DATE",
	EMPLOYEE_SET_TERMINATION_DATE: "EMPLOYEE_SET_TERMINATION_DATE",
	EMPLOYEE_SET_SALARY: "EMPLOYEE_SET_SALARY",
	EMPLOYEE_SET_TAX: "EMPLOYEE_SET_TAX",
	EMPLOYEE_DELETING_TAX: "EMPLOYEE_DELETING_TAX",
	EMPLOYEE_DELETED_TAX: "EMPLOYEE_DELETED_TAX",
	EMPLOYEE_DELETE_TAX_MODAL: "EMPLOYEE_DELETE_TAX_MODAL",
	EMPLOYEE_NEW_MODAL_OPEN: "EMPLOYEE_NEW_MODAL_OPEN",
	EMPLOYEE_UPDATED: "EMPLOYEE_UPDATED",
	EMPLOYEE_COLA_MODAL: "EMPLOYEE_COLA_MODAL",
	EMPLOYEE_SET_COLA: "EMPLOYEE_SET_COLA",
	EMPLOYEE_SET_CARRYOVER: "EMPLOYEE_SET_CARRYOVER",
	EMPLOYEE_SET_COLA_ROUNDING: "EMPLOYEE_SET_COLA_ROUNDING",
	EMPLOYEE_SET_COLA_PRE_APPLIED: "EMPLOYEE_SET_COLA_PRE_APPLIED",
	EMPLOYEE_COLA_APPLY: "EMPLOYEE_COLA_APPLY",
	EMPLOYEE_COLA_APPLYING: "EMPLOYEE_COLA_APPLYING",
	EMPLOYEE_CARRYOVER_APPLY: "EMPLOYEE_CARRYOVER_APPLY",
	EMPLOYEE_CARRYOVER_APPLYING: "EMPLOYEE_CARRYOVER_APPLYING",
	EMPLOYEE_NEW_DETAILS_SALARY: "EMPLOYEE_NEW_DETAILS_SALARY",
	EMPLOYEE_NEW_DETAILS_PREVIOUS_EARNINGS: "EMPLOYEE_NEW_DETAILS_PREVIOUS_EARNINGS",
	EMPLOYEE_NEW_DETAILS_TAX: "EMPLOYEE_NEW_DETAILS_TAX",
	EMPLOYEE_NEW_DETAILS_ROLE: "EMPLOYEE_NEW_DETAILS_ROLE",
	EMPLOYEE_DELETE_MODAL: "EMPLOYEE_DELETE_MODAL",
	EMPLOYEE_MFA_STATUS_MODAL: "EMPLOYEE_MFA_STATUS_MODAL",
	EMPLOYEE_RESET_MFA: "EMPLOYEE_RESET_MFA",
	EMPLOYEE_CLEAR: "EMPLOYEE_CLEAR",
	EMPLOYEE_PAYMENT_HISTORY_MODAL: "EMPLOYEE_PAYMENT_HISTORY_MODAL",
	EMPLOYEE_ATTACHMENT_EARNINGS_MODAL: "EMPLOYEE_ATTACHMENT_EARNINGS_MODAL",
	EMPLOYEE_ATTACHMENT_EARNINGS_LIST: "EMPLOYEE_ATTACHMENT_EARNINGS_LIST",
	EMPLOYEE_ATTACHMENT_EARNINGS_LOADING: "EMPLOYEE_ATTACHMENT_EARNINGS_LOADING",
	EMPLOYEE_ATTACHMENT_EARNINGS_SAVING: "EMPLOYEE_ATTACHMENT_EARNINGS_SAVING",
	EMPLOYEE_CHILDREN_MODAL: "EMPLOYEE_CHILDREN_MODAL",
	EMPLOYEE_CHILDREN_LOADING: "EMPLOYEE_CHILDREN_LOADING",
	EMPLOYEE_CHILDREN_SAVING: "EMPLOYEE_CHILDREN_SAVING",
	EMPLOYEE_CHILDREN_LIST: "EMPLOYEE_CHILDREN_LIST",
	EMPLOYEE_CHILD_LEAVE_MODAL: "EMPLOYEE_CHILD_LEAVE_MODAL",
	EMPLOYEE_PENSION_ENROLMENT: "EMPLOYEE_PENSION_ENROLMENT",
	EMPLOYEE_SET_ROLE: "EMPLOYEE_SET_ROLE",
	EMPLOYEE_SET_DEPARTMENT: "EMPLOYEE_SET_DEPARTMENT",
	EMPLOYEE_DELETE_DETAILS_MODAL: "EMPLOYEE_DELETE_DETAILS_MODAL",
	EMPLOYEE_DELETING_DETAILS_MODAL: "EMPLOYEE_DELETING_DETAILS_MODAL",
	EMPLOYEE_UPDATE_DETAILS_MODAL: "EMPLOYEE_UPDATE_DETAILS_MODAL",
	EMPLOYEE_UPDATING_DETAILS_MODAL: "EMPLOYEE_UPDATING_DETAILS_MODAL",
	EMPLOYEES_UPLOAD_PREVIOUS_EARNINGS_TEMPLATE: "EMPLOYEES_UPLOAD_PREVIOUS_EARNINGS_TEMPLATE",
	EMPLOYEE_PE_UPLOADED: "EMPLOYEE_PE_UPLOADED",
	EMPLOYEE_PE_UPLOADING: "EMPLOYEE_PE_UPLOADING",
	EMPLOYEE_UPDATED_INFO: "EMPLOYEE_UPDATED_INFO",
	EMPLOYEE_BACKPAY_CALCULATING: "EMPLOYEE_BACKPAY_CALCULATING",
	EMPLOYEE_BACKPAY_CALCULATED: "EMPLOYEE_BACKPAY_CALCULATED",
	EMPLOYEES_SENT_INVITE_AGREEMENT: "EMPLOYEES_SENT_INVITE_AGREEMENT",
	EMPLOYEE_SET_BULK_CHANGES_MODAL: "EMPLOYEES_SET_BULK_CHANGES_MODAL",
	EMPLOYEES_CLEAR_IMPORT_RESULTS: "EMPLOYEES_CLEAR_IMPORT_RESULTS",
	EMPLOYEES_PROCESSING_IMPORT: "EMPLOYEES_PROCESSING_IMPORT",
	EMPLOYEE_SAVE_FILTERS: "EMPLOYEE_SAVE_FILTERS",
};

const updatedEmployee = (created, employee) => ({
	type: Types.EMPLOYEE_UPDATED,
	created,
	employee,
});

const updateAgreementInfo = (data) => ({
	type: Types.EMPLOYEE_UPDATED_INFO,
	data,
});

const deleteAgreementModal = (open, message, agreement) => ({
	type: Types.EMPLOYEE_DELETE_MODAL,
	open,
	message,
	agreement,
});

const togglePaymentHistoryModal = ({ open, payments }) => ({
	type: Types.EMPLOYEE_PAYMENT_HISTORY_MODAL,
	open,
	payments,
});
const toggleChildrenModal = ({ open, child }) => ({
	type: Types.EMPLOYEE_CHILDREN_MODAL,
	open,
	child,
});
const toggleChildLeaveModal = ({ open, child, newEntry, leave }) => ({
	type: Types.EMPLOYEE_CHILD_LEAVE_MODAL,
	open,
	child,
	newEntry,
	leave,
});
const childrenLoading = (toggle) => ({
	type: Types.EMPLOYEE_CHILDREN_LOADING,
	toggle,
});
const savingChild = (toggle) => ({
	type: Types.EMPLOYEE_CHILDREN_SAVING,
	toggle,
});
const childrenList = (list, leave) => ({
	type: Types.EMPLOYEE_CHILDREN_LIST,
	list,
	leave,
});

const getChildren = (agreement) => {
	return async (dispatch, getState) => {
		const state = getState();
		agreement = agreement ? agreement : state.employee?.employeeDetails?.id;

		dispatch(childrenLoading(true));
		await fetch(apiURL + `/settings/agreement/${agreement}/children`, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(childrenList(data.children, data.leave));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Getting Children", "Children");
			});
		dispatch(childrenLoading());
	};
};

const getTotalsToDate = (agreement) => {
	return async (dispatch, getState) => {
		const state = getState();
		agreement = agreement ? agreement : state.employee?.employeeDetails?.id;

		await agreementRequest({
			method: "GET",
			path: `${agreement}/totalsToDate`,
		})
			.then(({ data }) => {
				dispatch(updateAgreementInfo({ totalsToDate: data }));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Getting Totals To Date", "Totals To Date");
			});
	};
};

const saveChild = ({ item, agreement }) => {
	return async (dispatch, getState) => {
		const state = getState();
		agreement = agreement ? agreement : state.employee?.employeeDetails?.id;

		dispatch(savingChild(true));
		await fetch(apiURL + `/settings/agreement/${agreement}/children`, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify(item),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(getChildren());
				dispatch(toggleChildrenModal({ open: false }));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Saving Child Details", "Children");
			});
		dispatch(savingChild());
	};
};
const toggleAttachmentEarningsModal = ({ open, attachment, defaultType }) => ({
	type: Types.EMPLOYEE_ATTACHMENT_EARNINGS_MODAL,
	open,
	attachment,
	defaultType,
});
const longTermAdjustmentsLoading = (toggle) => ({
	type: Types.EMPLOYEE_ATTACHMENT_EARNINGS_LOADING,
	toggle,
});
const savingAttachmentEarnings = (toggle) => ({
	type: Types.EMPLOYEE_ATTACHMENT_EARNINGS_SAVING,
	toggle,
});
const longTermAdjustmentsList = (list) => ({
	type: Types.EMPLOYEE_ATTACHMENT_EARNINGS_LIST,
	list,
});

const getLongTermAdjustments = (agreement) => {
	return async (dispatch, getState) => {
		const state = getState();
		agreement = agreement ? agreement : state.employee?.employeeDetails?.id;

		dispatch(longTermAdjustmentsLoading(true));
		await fetch(apiURL + `/settings/agreement/${agreement}/attachment-of-earnings`, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(longTermAdjustmentsList(data.adjustments));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Getting Attachment of Earnings", "Attachment of Earnings");
			});
		dispatch(longTermAdjustmentsLoading());
	};
};

const saveLongTermAdjustments = ({ item, agreement }) => {
	return async (dispatch, getState) => {
		const state = getState();
		agreement = agreement ? agreement : state.employee?.employeeDetails?.id;

		dispatch(savingAttachmentEarnings(true));
		await fetch(apiURL + `/settings/agreement/${agreement}/attachment-of-earnings`, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify(item),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(getLongTermAdjustments());
				dispatch(toggleAttachmentEarningsModal({ open: false }));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Saving Attachment of Earnings", "Attachment of Earnings");
			});
		dispatch(savingAttachmentEarnings());
	};
};

const deleteAgreementData = (agreement, confirmation) => {
	return (dispatch, getState) => {
		const state = getState();
		const employee = state?.employees?.employeeListWithSalary?.find((employee) => employee.id == agreement);

		request({
			method: "DELETE",
			path: `admin/agreement/${agreement}`,
			body: { confirmation },
		})
			.then(({ data }) => {
				if (data.processed[0].error) {
					dispatch(deleteAgreementModal(true, data.processed[0].error.message, agreement));
				} else {
					dispatch(deleteAgreementModal(false));
					NotificationManager.success(
						`${employee.employeeName} ${employee.employeeSurname} Has Been Successfully Deleted!`,
						"Delete Agreement",
					);
				}
				dispatch(
					employeesGetListWithSalary({
						from: format(addMonths(new Date(), -2), "yyyy-MM-01"), // get list from last 2 months
						to: format(new Date(), "yyyy-12-31"),
					}),
				);
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("An Error Has Occurred", "Delete Agreement");
			});
	};
};

const createNewEmployee = (body, onSuccess) => {
	return async (dispatch, getState) => {
		const state = getState();

		body.id = state.employee?.agreementInfo?.id || uuidv4();

		body.employeeDetails = {
			...state.employee?.agreementInfo?.employeeDetails,
			...body.employeeDetails,
		};

		await agreementRequest({
			method: "POST",
			path: "",
			body,
		})
			.then((data) => {
				dispatch(getEmployeeDetails(body.id));
				if (onSuccess) onSuccess();
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Creating New Employee", "Create New Employee");
			});
	};
};

const removeGradeLock = () => ({
	type: Types.EMPLOYEE_UNLINK_GRADE,
});

const updateEmployee = (body) => {
	return (dispatch, getState) => {
		const state = getState();
		const agreementId = state.employee?.employeeDetails?.id;
		dispatch(updatedEmployee(false, body));
		fetch(apiURL + `/settings/agreement/${agreementId}`, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify(body),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {});
	};
};

const saveCarryover = () => {
	return (dispatch, getState) => {
		const state = getState();
		dispatch(carryoverBeingApplied());
		fetch(apiURL + `/settings/carryover`, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify(state.employees.carryover),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(carryoverAppliedResult(data));
				dispatch(LEAVE_ACTIONS.leaveCarryoverModal(false));
				dispatch(COMPANY_ACTIONS.getCompanySettings());
				NotificationManager.success("Leave has been carried over successfully!", "Leave Carryover");
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error(`Failed to carryover leave`, "Leave Carryover");
			});
	};
};

const carryoverBeingApplied = () => ({
	type: Types.EMPLOYEE_CARRYOVER_APPLYING,
});

const carryoverAppliedResult = (payload) => ({
	type: Types.EMPLOYEE_CARRYOVER_APPLY,
	response: payload,
});

const validateCarryover = (agreementId, carryover, payable) => {
	return (dispatch, getState) => {
		const state = getState();
		// const {maxCarryover, maxPayable} = state?.leave?.leaveCarryoverMax
		const totalLeave =
			parseFloat(
				state?.leave?.leaveBalancesByType?.[6020]
					?.find((a) => a.agreementId == agreementId)
					?.balanceThisYear?.toFixed(2),
			) || 0;
		const carryoverToCompare = parseFloat(carryover) || 0;
		const payableToCompare = parseFloat(payable) || 0;
		const total = payableToCompare + carryoverToCompare;

		if (carryoverToCompare < 0) carryover = 0;
		if (payableToCompare < 0) payable = 0;

		let valid =
			!isNaN(carryover) &&
			!isNaN(payable) &&
			((total <= totalLeave && carryoverToCompare >= 0) || (totalLeave < 0 && total == 0));

		dispatch(setEmployeeCarryover(agreementId, carryover, payable, valid));
	};
};

const colaBeingApplied = () => ({
	type: Types.EMPLOYEE_COLA_APPLYING,
});

const colaAppliedResult = (payload) => ({
	type: Types.EMPLOYEE_COLA_APPLY,
	response: payload,
});
const colaRequired = (payload) => ({
	type: Types.EMPLOYEE_COLA_REQUIRED,
	data: payload,
});

const getAutoEnrolment = (payrunId, query) => {
	const { startDate, endDate } = query || {};

	return async (dispatch, getState) => {
		const state = getState();
		await request({
			method: "GET",
			path: `verify-payrun/${payrunId}`,
		})
			.then(({ data }) => {
				const { enrolment } = data;
				if (enrolment?.salariesEnrolled > 0) dispatch(NOTIFICATION_ACTIONS.getNotifications());
			})
			.catch((error) => {
				console.error("error", error);
			});
		if (state.integration?.pension?.peoplesPension)
			dispatch(PEOPLES_PENSION_ACTIONS.getOptOuts({ startDate, endDate }));
	};
};

const getPensionEnrolment = (query, params) => {
	return async (dispatch, getState) => {
		const state = getState();
		if (["MT"].includes(state.company?.settings?.jurisdiction)) return;
		const { agreement } = { ...params };
		const agreementId = agreement ? agreement : state.employee.agreementInfo.id;

		await agreementRequest({
			method: "GET",
			path: `${agreementId}/pension-enrolment`,
			query,
		}).then(({ data }) => {
			dispatch(pensionEnrolment(data.enrolment));
		});
	};
};

const saveAgreementPension = (input, params) => {
	return async (dispatch, getState) => {
		const { agreement, notification, suppressNotification } = { ...params };

		const state = getState();

		// if (newEmployee) dispatch(updatedEmployee(false, input));

		const agreementId = agreement ? agreement : state.employee.agreementInfo.id;
		await agreementRequest({
			method: "POST",
			path: `${agreementId}/pension`,
			body: cleanDeep(input),
		})
			.then(({ data }) => {
				const pensionPlans = state.employee?.pensionPlans || [];
				dispatch(updateAgreementInfo({ pensionPlans: _.uniqBy([data, ...pensionPlans], "id") }));
				if (!suppressNotification) {
					NotificationManager.success("Successfully Saved Pension Plan", "Save Pension Plan");
				}
				if (notification) dispatch(NOTIFICATION_ACTIONS.deleteNotification(notification));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Saving Pension Plan", "Save Pension Plan");
			});
	};
};

const putAgreementPension = (input, params) => {
	return async (dispatch, getState) => {
		const { agreement, notification, suppressNotification } = { ...params };

		const state = getState();

		// if (newEmployee) dispatch(updatedEmployee(false, input));

		const agreementId = agreement ? agreement : state.employee.agreementInfo.id;
		await agreementRequest({
			method: "PUT",
			path: `${agreementId}/pension`,
			body: cleanDeep(input),
		})
			.then(({ data }) => {
				const pensionPlans = state.employee?.pensionPlans || [];
				dispatch(updateAgreementInfo({ pensionPlans: _.uniqBy([data, ...pensionPlans], "salaryId") }));
				if (!suppressNotification) {
					NotificationManager.success("Successfully Saved Pension Plan", "Save Pension Plan");
				}
				if (notification) dispatch(NOTIFICATION_ACTIONS.deleteNotification(notification));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Saving Pension Plan", "Save Pension Plan");
			});
	};
};

const getCola = () => {
	return (dispatch, getState) => {
		const state = getState();

		const currentYear = format(new Date(), "yyyy");

		const daysBeforeEndOfYear = differenceInCalendarDays(new Date(`${currentYear}-12-31`), new Date());
		const reminderInterval = 25;

		const referenceDate =
			daysBeforeEndOfYear <= reminderInterval
				? format(addYears(new Date(), 1), "yyyy-01-01")
				: format(new Date(), "yyyy-01-01");
		const isAfter2023 = referenceDate >= "2023-01-01";

		if (!isAfter2023) return;

		try {
			fetch(apiURL + `/settings/cola`, {
				credentials: "include",
				method: "GET",
				headers: {
					"Accept": "application/json",
					"Content-Type": "application/json",
				},
			})
				.then((response) => response.json())
				.then((data) => {
					dispatch(colaRequired(data));
				});
		} catch (error) {
			console.error("error", error);
		}
	};
};

const applyCola = () => {
	return (dispatch, getState) => {
		const state = getState();
		dispatch(colaBeingApplied());

		const date = state.cola.referenceDate;
		const applyPeriodDate = !!state.cola.applyFirstPeriod;
		const newSalaries = Object.entries(state.cola.salaries)
			.map(([key, value]) => ({ key, value: value.salary }))
			.reduce(
				(preValue, currValue) => ({
					...preValue,
					[currValue.key]: currValue.value,
				}),
				{},
			);
		const numberOfEmployees = Object.keys(newSalaries).length;

		fetch(apiURL + `/settings/cola`, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify({
				newSalaries,
				date,
				applyPeriodDate,
			}),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(colaAppliedResult(data));
				// refresh employee list
				dispatch(
					employeesGetListWithSalary(
						{
							from: format(addMonths(new Date(), -2), "yyyy-MM-01"), // get list from last 2 months
							to: format(new Date(), "yyyy-12-31"),
						},
						{ includeTax: true },
					),
				);
				dispatch(getCola());
				NotificationManager.success(
					`Cost of Living was applied successfully to ${numberOfEmployees} employee${
						numberOfEmployees == 1 ? "" : "s"
					}!`,
					"Applying COLA",
				);
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error(`Failed to Apply Cost of Living`, "Applying COLA");
			});
	};
};

const setEmployeeCarryover = (agreementId, carryover, toPay, isValid) => ({
	type: Types.EMPLOYEE_SET_CARRYOVER,
	agreementId,
	carryover,
	toPay,
	isValid,
});

const setColaRounding = () => ({
	type: Types.EMPLOYEE_SET_COLA_ROUNDING,
});

const setColaPreApplied = () => ({
	type: Types.EMPLOYEE_SET_COLA_PRE_APPLIED,
});

const setColaFirstInPeriod = () => ({
	type: Types.EMPLOYEE_COLA_PERIOD,
});

const setEmployeeCOLA = (agreementId, newSalary) => ({
	type: Types.EMPLOYEE_SET_COLA,
	agreementId,
	newSalary,
});

const showInviteEmployeeModal = (status) => ({
	type: Types.EMPLOYEES_SHOW_INVITE_MODAL,
	status,
});

const showCOLAModal = (status) => ({
	type: Types.EMPLOYEE_COLA_MODAL,
	status,
});

const employeesUpdateList = (response) => ({
	type: Types.EMPLOYEES_UPDATE_LIST,
	payload: response,
});

const setNewEmployeeModal = (isNewEmployeeModalOpen, keepEmployee, details) => ({
	type: Types.EMPLOYEE_NEW_MODAL_OPEN,
	isNewEmployeeModalOpen,
	keepEmployee,
	details,
});

const employeesGetList = () => {
	return (dispatch, getState) => {
		fetch(apiURL + `/settings/employees`, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(employeesUpdateList(data));
			});
	};
};

const taxOptions = (response) => ({
	type: Types.EMPLOYEE_TAX_OPTIONS,
	payload: response,
});

const getTaxOptions = (agreement) => {
	return async (dispatch, getState) => {
		const state = getState();

		const agreementId = agreement ? agreement : state.employee?.agreementInfo?.id;

		await request({
			method: "GET",
			path: `taxOptions${constructQueryParams({ agreementId })}`,
		})
			.then(({ data }) => {
				dispatch(taxOptions(data));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Getting Tax Options", "Tax Options");
			});
	};
};

const employeesUpdateTerminatedList = (response) => ({
	type: Types.EMPLOYEES_UPDATE_TERMINATED_LIST,
	payload: response,
});

const getTerminatedEmployees = () => {
	return (dispatch, getState) => {
		// get employees if not already loaded - then they are filtered later
		const state = getState();
		const date = state.payroll?.payPeriodDetails?.periodStart;
		const dateObj = date ? parse(date, "yyyy-MM-dd", new Date()) : new Date();

		dispatch(
			employeesGetListWithSalary({
				from: format(addMonths(dateObj, -2), "yyyy-MM-01"), // get list from last 2 months
				to: format(dateObj, "yyyy-12-31"),
			}),
		);

		// fetch(apiURL + `/settings/employees/terminated`, {
		//   credentials: 'include',
		//   method: 'GET',
		//   headers: {
		//     'Accept': 'application/json',
		//     'Content-Type': 'application/json',
		//   },
		// })
		//   .then(response => response.json())
		//   .then(data => {
		//     dispatch(employeesUpdateTerminatedList(data))
		//   })
	};
};

const employeesUpdateListWithSalary = (response) => ({
	type: Types.EMPLOYEES_UPDATE_LIST_WITH_SALARY,
	payload: response,
});

const employeesGetListWithSalary = ({ from, to }, query) => {
	return (dispatch, getState) => {
		const queryParams = query ? `?${new URLSearchParams(query).toString()}` : "";

		request({
			path: `employeesWithSalary/${from}/${to}${queryParams}`,
			method: "GET",
		}).then(({ data }) => {
			dispatch(employeesUpdateListWithSalary(data));

			const state = getState();

			if (state.deputy?.connected) {
				dispatch(DEPUTY_ACTIONS.getDeputyEmployees());
			}
		});
	};
};

const updateInviteSendStatus = (sent, total) => ({
	type: Types.EMPLOYEES_INVITE_SENT_STATUS,
	sent,
	total,
});

const updateSingleInviteSending = (status) => ({
	type: Types.EMPLOYEES_SINGLE_INVITE_SENDING_STATUS,
	status,
});

const updateSentEmployeeAgreement = (status) => ({
	type: Types.EMPLOYEES_SENT_INVITE_AGREEMENT,
	status,
});

const sendInvite = (agreementId) => {
	return async (dispatch, getState) => {
		const state = getState();

		if (!state.employee?.agreementInfo?.employeeDetails?.email) {
			NotificationManager.error("Cannot invite an employee without an email address", "Inviting Employee");
			return;
		}

		dispatch(updateSingleInviteSending(true));

		await fetch(apiURL + `/settings/inviteEmployee`, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify({ id: agreementId }),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				console.debug("response", data);
				NotificationManager.success("Employee Invited Successfully!", "Inviting Employee");
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Inviting Employee", "Inviting Employee");
			});

		dispatch(updateSentEmployeeAgreement(agreementId));
		dispatch(updateSingleInviteSending(false));
	};
};

const sendInvites = (department) => {
	return async (dispatch, getState) => {
		const state = getState();

		const toSend = state.employees?.employeeListWithSalary?.filter(
			(employee) => !department || employee.department == department,
		);

		let sent = 0;
		dispatch(updateInviteSendStatus(sent, toSend?.length));

		const chunkedList = _.chunk(toSend, 5);

		const allowanceList = state.allowances.allowanceList;

		for (var i = chunkedList.length - 1; i >= 0; i--) {
			await Promise.all(
				chunkedList[i].map(async (employee) => {
					request({
						method: "POST",
						path: "inviteEmployee",
						body: JSON.stringify({ id: employee.id }),
					});

					sent++;
					dispatch(updateInviteSendStatus(sent, toSend.length));
				}),
			);
		}
	};
};

// Redux Action for Single Employee
const setEmployeeDetails = (response) => ({
	type: Types.EMPLOYEE_DETAILS,
	payload: response,
});

const getEmployeeDetails = (agreementId) => {
	return async (dispatch, getState) => {
		const state = getState();

		await agreementRequest({
			method: "GET",
			path: `${agreementId}`,
		})
			.then(({ data }) => {
				dispatch(setEmployeeDetails({ ...data }));
			})
			.catch((error) => {
				if (error.isAxiosError && error.response) {
					NotificationManager.error(`Error: ${error.response?.data?.error}`, "Employee Details");
					dispatch(setEmployeeDetails({ ...error.response.data }));
				} else {
					console.error(error.stack);
					NotificationManager.error("Error Getting Employee Details", "Employee Details");
					dispatch(setEmployeeDetails({ error: "Error Getting Employee Details" }));
				}
			});
	};
};

// Redux Action for Single Employee
const setAuditLogs = (data, nextToken) => ({
	type: Types.EMPLOYEE_AUDIT_LOGS,
	data,
	nextToken,
	extend: nextToken ? true : false,
});

const clearEmployee = () => ({
	type: Types.EMPLOYEE_CLEAR,
});

const getEmployeeAuditLogs = ({ agreementId, nextToken, from, to }) => {
	return async (dispatch, getState) => {
		const query = cleanDeep({
			agreementId,
			from: from && format(from, "yyyy-MM-dd"),
			to: to && format(to, "yyyy-MM-dd"),
			nextToken,
		});

		request({
			method: "GET",
			path: `auditLogs/agreement/${agreementId}`,
			query,
		}).then(({ data }) => {
			dispatch(setAuditLogs(data, nextToken));
		});
	};
};

// Redux Action for Single Employee
const setNotes = (response, nextToken) => ({
	type: Types.EMPLOYEE_NOTES,
	payload: response,
	extend: nextToken ? true : false,
});

const pensionEnrolment = (response) => ({
	type: Types.EMPLOYEE_PENSION_ENROLMENT,
	response,
});

const getEmployeeNotes = ({ agreementId, nextToken, from, to }) => {
	return async (dispatch, getState) => {
		const state = getState();

		const qs = new URLSearchParams(
			cleanDeep({
				from,
				to,
				nextToken,
			}),
		).toString();

		const response = await fetch(apiURL + `/settings/notes/agreement/${agreementId}?${qs}`, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(setNotes(data, nextToken));
			});
	};
};

const savedEmployeeDetails = (response) => ({
	type: Types.EMPLOYEE_SAVED_DETAILS,
	payload: response,
});

const saveEmployeeDetails = (input, newEmployee, params = {}) => {
	return async (dispatch, getState) => {
		const { agreement, notification, suppressNotification, onSuccess } = params;

		const state = getState();

		if (newEmployee) dispatch(updatedEmployee(false, input));

		const agreementId = agreement ? agreement : state.employee.agreementInfo.id;

		const response = await agreementRequest({
			path: `${agreementId}`,
			method: "POST",
			body: input,
		}).then(({ data }) => {
			if (notification) {
				dispatch(NOTIFICATION_ACTIONS.deleteNotification(notification));
			} else {
				dispatch(getEmployeeDetails(agreementId));
			}
			if (!suppressNotification) {
				NotificationManager.success("Employee Details Saved Successfully!", "Saving Employee Details");
			}
			if (onSuccess) onSuccess();
		});
	};
};

const deleteSalaryModal = (status) => {
	return (dispatch, getState) => {
		const state = getState();
		const { salaries: employeeSalaries } = state.employee;
		const salaries = mapSalariesForDropdown(employeeSalaries, state.company?.settings?.currency);
		const salary = salaries?.[salaries.length - 1];

		dispatch(deleteDetailsModal({ status, item: salary, tab: "salary" }));
	};
};

const mfaStatusModal = (toggle) => ({
	type: Types.EMPLOYEE_MFA_STATUS_MODAL,
	toggle,
});

const updateDetailsModal = ({
	status,
	tab,
	minDate,
	maxDate,
	existingList,
	onlyReplace,
	params,
	onlyNew,
	noDatePrompt,
}) => ({
	type: Types.EMPLOYEE_UPDATE_DETAILS_MODAL,
	status,
	existingList,
	minDate,
	maxDate,
	tab,
	onlyReplace,
	onlyNew,
	noDatePrompt,
	params,
});

const updatingDetailsModal = (status) => ({
	type: Types.EMPLOYEE_UPDATING_DETAILS_MODAL,
	status,
});

const updateDetails = ({ replace, effectiveFrom, tab, data, agreement }) => {
	return async (dispatch, getState) => {
		const state = getState();
		const agreementID = agreement ? agreement : state.employee?.agreementInfo?.id;
		let path = "";
		let body = { effectiveFrom, replace: !!replace };
		switch (tab) {
			case "department":
				path = `${agreementID}/department`;
				body["input"] = data;
				break;
			case "Enrolment Postponement":
				path = `${agreementID}/postpone-auto-enrolment`;
				body = data;
				break;
			case "occupation":
				path = `${agreementID}/occupation`;
				body["input"] = data;
				break;
		}

		await dispatch(updatingDetailsModal(true));

		await agreementRequest({
			method: "POST",
			path,
			body,
		})
			.then(async ({ data }) => {
				await dispatch(getEmployeeDetails(agreementID));
				await dispatch(updateDetailsModal({ status: false }));
				NotificationManager.success(`Successfully updated ${tab}`, `Update ${toTitleCase(tab)} Details`);
				return data[tab];
			})
			.then((data) => {
				switch (tab) {
					case "occupation":
						window.history.pushState(null, null, `/organisation/people/${agreementID}/roles/${data}/role`);
						break;
				}
			})
			.catch((error) => {
				console.error(error);
				dispatch(updatingDetailsModal(false));
				NotificationManager.error(`Error Updating ${tab}`, `Update ${toTitleCase(tab)} Details`);
			});
	};
};

const deleteEmployeeDetails = ({ tab, id, agreement, body }) => {
	return async (dispatch, getState) => {
		const state = getState();
		const agreementID = agreement ? agreement : state.employee?.agreementInfo?.id;
		let url = "";
		switch (tab) {
			case "department":
				url = `${agreementID}/department/${id}`;
				break;
			case "role":
				url = `${agreementID}/role/${id}`;
				break;
			case "salary":
				url = `${agreementID}/salary/${id}`;
				break;
			case "tax":
				url = `${agreementID}/tax/${id}`;
				break;
			case "pension":
				url = `${agreementID}/pension/${id}`;
				break;
			case "occupation":
				url = `${agreementID}/termination/${id}`;
				break;
		}

		if (!url) return;

		dispatch(deletingDetailsModal(true));

		await agreementRequest({
			method: "DELETE",
			path: url,
			body,
		})
			.then(({ data }) => {
				dispatch(getEmployeeDetails(agreementID));
				dispatch(deleteDetailsModal({ status: false }));
				NotificationManager.success(`Successfully deleted ${tab}`, `Delete ${toTitleCase(tab)} Details`);
			})
			.catch((error) => {
				console.error(error);
				dispatch(deleteDetailsModal(false));
				NotificationManager.error(`Error Deleting ${tab}`, `Delete ${toTitleCase(tab)} Details`);
			});
	};
};

const updatePostponeDateModal = (status) => {
	return (dispatch, getState) => {
		const { agreementInfo } = getState().employee;
		const { engagementDate } = agreementInfo;
		const minDate = engagementDate;
		dispatch(updateDetailsModal({ status, minDate, onlyReplace: true, tab: "Enrolment Postponement" }));
	};
};

const updateDepartmentModal = (status, params) => {
	return (dispatch, getState) => {
		const { departments, agreementInfo } = getState().employee;
		const { engagementDate, terminationDate } = agreementInfo;
		const department = departments?.[departments.length - 1];
		const departmentStart = department ? parse(department?.start, "yyyy-MM-dd", new Date()) : undefined;
		const minDate = (() => {
			if (departmentStart) return format(addDays(departmentStart, 1), "yyyy-MM-dd");
			if (engagementDate) return engagementDate;
		})();
		const maxDate = (() => {
			if (!["null", "undefined"].includes(String(terminationDate)))
				return format(new Date(terminationDate), "yyyy-MM-dd");
		})();
		dispatch(
			updateDetailsModal({ status, minDate, maxDate, tab: "department", existingList: departments, params }),
		);
	};
};

const newOccupationModal = (status) => {
	return (dispatch, getState) => {
		dispatch(
			updateDetailsModal({ status, tab: "occupation", existingList: [], noDatePrompt: true, onlyNew: true }),
		);
	};
};

const deleteDetailsModal = ({ status, tab, item, action }) => ({
	type: Types.EMPLOYEE_DELETE_DETAILS_MODAL,
	status,
	item,
	tab,
	action,
});

const deletingDetailsModal = (status) => ({
	type: Types.EMPLOYEE_DELETING_DETAILS_MODAL,
	status,
});

const deleteDepartmentModal = (status) => {
	return (dispatch, getState) => {
		const state = getState();
		const { departments, agreementInfo } = state.employee;
		const { terminationDate, engagementDate } = agreementInfo;
		const { departments: departmentList } = state.company?.settings;
		const department = departments?.[departments.length - 1];

		let endDate = ["null", undefined].includes(department.end)
			? "Now"
			: format(new Date(department.end), "do MMM yyyy");

		const name = departmentList?.find(({ id }) => id === department.department)?.name;

		if (["null", undefined].includes(department.end)) {
			endDate = terminationDate ? format(new Date(terminationDate), "do MMM yyyy") : endDate;
		}

		const startDate = format(new Date(department.start ? department.start : engagementDate), "do MMM yyyy");

		const item = { label: `${name} (${startDate} - ${endDate})`, value: department.id };
		dispatch(deleteDetailsModal({ status, item, tab: "department" }));
	};
};

const deleteRoleModal = (status) => {
	return (dispatch, getState) => {
		const state = getState();

		const { roles, agreementInfo } = state.employee;
		const { terminationDate, engagementDate } = agreementInfo;
		const role = roles?.[roles.length - 1];
		let endDate = ["null", undefined].includes(role.end) ? "Now" : format(new Date(role.end), "do MMM yyyy");

		if (["null", undefined].includes(role.end)) {
			endDate = terminationDate ? format(new Date(terminationDate), "do MMM yyyy") : endDate;
		}

		const startDate = format(new Date(role.start ? role.start : engagementDate), "do MMM yyyy");
		const item = { label: `${startDate} - ${endDate} | ${role.name}`, value: role?.id };
		dispatch(deleteDetailsModal({ status, item, tab: "role" }));
	};
};

const deleteTaxModal = (status) => {
	return (dispatch, getState) => {
		const state = getState();
		const { taxSettings: employeeTaxes } = state.employee;
		const taxes = mapTaxesForDropdown(employeeTaxes, state.company?.settings?.currency);
		const tax = taxes?.[taxes.length - 1];

		dispatch(deleteDetailsModal({ status, item: tax, tab: "tax" }));
	};
};

const deletePensionModal = (status) => {
	return (dispatch, getState) => {
		const state = getState();
		const { pensionPlans: employeePensions } = state.employee;
		const groups = state.pensions.group.list;
		const pensions = mapPensionsForDropdown(employeePensions, groups);
		const pension = pensions?.[pensions.length - 1];

		dispatch(deleteDetailsModal({ status, item: pension, tab: "pension" }));
	};
};

const deletingTaxSetting = () => ({
	type: Types.EMPLOYEE_DELETING_TAX,
});

const deletedTaxSetting = (response) => ({
	type: Types.EMPLOYEE_DELETED_TAX,
	payload: response,
});

const deletingSalary = () => ({
	type: Types.EMPLOYEE_DELETING_SALARY,
});

const deletedSalary = (response) => ({
	type: Types.EMPLOYEE_DELETED_SALARY,
	payload: response,
});

const deleteSalary = (salaryId) => {
	return async (dispatch, getState) => {
		dispatch(deletingSalary());

		const state = getState();

		const agreementId = state.employee.employeeDetails.id;

		const response = await fetch(apiURL + `/settings/agreement/${agreementId}/salary/${salaryId}`, {
			credentials: "include",
			method: "DELETE",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(deletedSalary(data));
				dispatch(getEmployeeDetails(agreementId));
			});
	};
};

const deletingPension = (status) => ({
	type: Types.EMPLOYEE_DELETING_PENSION,
	status,
});

const deletePension = (pensionId) => {
	return async (dispatch, getState) => {
		dispatch(deletingPension(true));

		const state = getState();

		const agreementId = state.employee.employeeDetails.id;

		await agreementRequest({
			method: "DELETE",
			path: `${agreementId}/pension/${pensionId}`,
		})
			.then(({ data }) => {
				dispatch(getEmployeeDetails(agreementId));
				dispatch(deletePensionModal());
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Deleting Pension", "Delete Pension");
				dispatch(deletingPension(false));
			});
	};
};

const deleteTaxSetting = (taxId) => {
	return async (dispatch, getState) => {
		dispatch(deletingTaxSetting());

		const state = getState();

		const agreementId = state.employee.employeeDetails.id;

		const response = await fetch(apiURL + `/settings/agreement/${agreementId}/tax/${taxId}`, {
			credentials: "include",
			method: "DELETE",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(deletedTaxSetting(data));
				dispatch(getEmployeeDetails(agreementId));
			});
	};
};

const savingModalChanges = (status) => ({
	type: Types.EMPLOYEE_SAVING_CHANGE_MODAL,
	status,
});

const savedModalChanges = (response) => ({
	type: Types.EMPLOYEE_SAVED_CHANGE_MODAL,
	payload: response,
});

const newEmployeeUpdatedSalary = (data) => ({
	type: Types.EMPLOYEE_NEW_DETAILS_SALARY,
	data,
});

const newEmployeeUpdatedPreviousEarnings = (data) => ({
	type: Types.EMPLOYEE_NEW_DETAILS_PREVIOUS_EARNINGS,
	data,
});

const newEmployeeUpdatedTax = (data) => ({
	type: Types.EMPLOYEE_NEW_DETAILS_TAX,
	data,
});

const newEmployeeUpdatedRole = (data) => ({
	type: Types.EMPLOYEE_NEW_DETAILS_ROLE,
	data,
});

const updateRole = (data, employmentDate) => {
	return async (dispatch, getState) => {
		const state = getState();

		const agreementId = state.employee?.employeeDetails?.id;

		const input = {
			input: data,
			effectiveFrom: employmentDate,
			replace: false,
		};

		const response = await fetch(apiURL + `/settings/agreement/${agreementId}/role`, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify(input),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((response) => dispatch(newEmployeeUpdatedRole(data)));
	};
};

const updatePreviousEarnings = (data, onSuccess) => {
	return async (dispatch, getState) => {
		const state = getState();

		const agreementId = state.employee?.employeeDetails?.id;

		const input = {
			input: data,
			effectiveFrom: state.employee?.employeeDetails?.engagementDate,
			replace: true,
		};

		await agreementRequest({
			method: "POST",
			path: `${agreementId}/previousEarnings`,
			body: input,
		})
			.then(async ({ data }) => {
				await dispatch(newEmployeeUpdatedPreviousEarnings(data));
				if (onSuccess) onSuccess();
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Saving Previous Earnings", "Save Previous Earnings");
			});
	};
};

const updateTaxDetails = (data) => {
	return async (dispatch, getState) => {
		const state = getState();

		const agreementId = state.employee?.employeeDetails?.id;

		const input = {
			input: data,
			effectiveFrom: state.employee?.employeeDetails?.engagementDate,
			replace: true,
		};

		const response = await fetch(apiURL + `/settings/agreement/${agreementId}/tax`, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify(input),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((response) => dispatch(newEmployeeUpdatedTax(data)));
	};
};

const updateSalary = (data) => {
	return async (dispatch, getState) => {
		const state = getState();

		const agreementId = state.employee?.employeeDetails?.id;

		const input = {
			input: data,
			effectiveFrom: state.employee?.employeeDetails?.engagementDate,
			replace: true,
		};

		await agreementRequest(apiURL + `/settings/agreement/${agreementId}/salary`, {
			method: "POST",
			path: `${agreementId}/salary`,
			body: JSON.stringify(input),
		}).then(({ data }) => dispatch(newEmployeeUpdatedSalary(data)));
	};
};

const confirmChange = ({ date, replace, agreement, notification, onSuccess, processBackpay }) => {
	return async (dispatch, getState) => {
		dispatch(savingModalChanges(true));

		const state = getState();

		const type = state.employee.confirmModal.type;

		const agreementId = agreement ? agreement : state.employee.agreementInfo.id;

		const input = {
			input: state.employee.confirmModal.input,
			effectiveFrom: date,
			processBackpay,
			replace,
		};

		const verb = replace ? "Updat" : "Creat";

		await agreementRequest({
			method: "POST",
			path: `${agreementId}/${_.camelCase(type)}`,
			body: input,
		})
			.then(({ data }) => {
				dispatch(savedModalChanges(data));
				if (notification) {
					dispatch(NOTIFICATION_ACTIONS.deleteNotification(notification));
				} else {
					dispatch(getEmployeeDetails(agreementId));
				}
				NotificationManager.success(`Successfully ${verb}ed ${type}`, `${verb}e ${toTitleCase(type)}`);
				if (onSuccess) onSuccess();
			})
			.catch((error) => {
				console.error(error);
				let message = `Error ${verb}ing ${type}`;
				if (error?.response?.data?.errors) {
					message = error.response.data.errors.join(", ");
				}
				NotificationManager.error(message, `${verb}e ${toTitleCase(type)}`);
				dispatch(savingModalChanges(false));
			});
	};
};

const backpayCalculating = (status) => ({
	type: Types.EMPLOYEE_BACKPAY_CALCULATING,
	status,
});
const backpayCalculated = (data) => ({
	type: Types.EMPLOYEE_BACKPAY_CALCULATED,
	data,
});

const calculateChangeImpact = ({ date, replace, agreement, notification }) => {
	return async (dispatch, getState) => {
		const state = getState();

		const type = state.employee.confirmModal.type;

		const backpayEnabled = state?.company?.settings?.enable?.backpay;

		console.log("type", type);
		if (type == "Salary" && backpayEnabled) {
			// we need to calculate backpay
			dispatch(backpayCalculating(true));
			const agreementId = agreement ? agreement : state.employee.agreementInfo.id;

			const input = {
				newSalary: state.employee.confirmModal.input,
				effectiveFrom: date ?? null,
				replace: !date,
				agreementId,
			};

			await request({
				method: "POST",
				path: `payroll/backpay`,
				body: input,
			})
				.then(({ data }) => {
					dispatch(backpayCalculated(data));
				})
				.catch((error) => {
					console.error(error);
					dispatch(backpayCalculating(false));
				});
		}
	};
};

const savingPreviousEarnings = () => ({
	type: Types.EMPLOYEE_SAVING_EARNINGS,
});
const savedPreviousEarnings = (response) => ({
	type: Types.EMPLOYEE_PREVIOUS_EARNINGS,
	payload: response,
});

const savePreviousEarnings = (options) => {
	return async (dispatch, getState) => {
		dispatch(savingPreviousEarnings());

		const state = getState();

		const type = "grade";

		const employeeId = state.employee.employeeDetails.employee_id;

		const response = await fetch(apiURL + `/settings/employee/${employeeId}/previousEarnings`, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify(options),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(savedPreviousEarnings(data));
				dispatch(getEmployeeDetails(employeeId));
			});
	};
};

const savedGrade = (response) => ({
	type: Types.EMPLOYEE_APPLY_GRADE,
	payload: response,
});

const confirmGrade = (options) => {
	return async (dispatch, getState) => {
		dispatch(savingModalChanges());

		const state = getState();

		const type = "grade";

		const agreementId = state.employee.employeeDetails.id;

		const response = await fetch(apiURL + `/settings/agreement/${agreementId}/${type.toLowerCase()}`, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify(options),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(savedGrade(data));
				dispatch(getEmployeeDetails(agreementId));
			});
	};
};

const savingBankDetails = () => ({
	type: Types.EMPLOYEE_SAVING_BANK,
});

const savedBankDetails = (response) => ({
	type: Types.EMPLOYEE_SAVED_BANK,
	payload: response,
});

const saveBankDetails = (input, agreement, notification, onSuccess) => {
	return async (dispatch, getState) => {
		dispatch(savingBankDetails());
		const state = getState();

		let agreementId = agreement ? agreement : state.employee?.employeeDetails?.id;

		await agreementRequest({
			method: "POST",
			path: `${agreementId}/bank`,
			body: input,
		})
			.then(async ({ data }) => {
				if (!!state?.integration?.payment?.fyorin) {
					await dispatch(FYORIN_ACTIONS.updateFyorinEmployee(agreementId));
				}
				if (notification) {
					await dispatch(NOTIFICATION_ACTIONS.deleteNotification(notification));
				}
				await dispatch(getEmployeeDetails(agreementId));
				if (onSuccess) onSuccess();
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Saving Bank Details", "Bank Details");
			});
	};
};

const savedPayByBank = (response) => ({
	type: Types.EMPLOYEE_SAVED_PAY_BY_BANK,
	payload: response,
});

const setPayByBank = (payByBank) => {
	return async (dispatch, getState) => {
		const state = getState();

		const agreementId = state.employee.employeeDetails.id;

		const response = await fetch(apiURL + `/settings/agreement/${agreementId}/payByBankTransfer`, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify({ payByBank }),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(savedPayByBank(data));
				dispatch(getEmployeeDetails(agreementId));
			});
	};
};

const savingEngagementDate = () => ({
	type: Types.EMPLOYEE_SAVING_ENGAGEMENT_DATE,
});

const updatedEngagementDate = (response) => ({
	type: Types.EMPLOYEE_UPDATED_ENGAGEMENT_DATE,
	payload: response,
});

const reviewEmploymentRole = (
	{ engagementDate, terminationDate, start, originalDate, notification, agreement },
	mappedData,
) => {
	return async (dispatch, getState) => {
		try {
			if (![null, undefined, "null"].includes(terminationDate)) {
				dispatch(setTerminationDate(terminationDate, { notification, agreement }));
			}
			if (![null, undefined, "null"].includes(engagementDate)) {
				dispatch(updateEngagementDate(engagementDate, { notification, agreement }));
			}
			dispatch(
				confirmModal({
					...mappedData,
					terminationDate: undefined,
					engagementDate: undefined,
					start: undefined,
				}),
			);
			const newDate = start == originalDate;
			dispatch(
				confirmChange({ date: newDate ? originalDate : start, replace: newDate, agreement, notification }),
			);
		} catch (error) {
			console.error(error);
		}
	};
};

const updateEngagementDate = (engagementDate, params, originalEngagement) => {
	return async (dispatch, getState) => {
		const { agreement, notification } = { ...params };

		if (!notification) dispatch(savingEngagementDate());

		const state = getState();

		const agreementId = agreement ? agreement : state.employee.employeeDetails.id;

		await agreementRequest({
			path: `${agreementId}/engagement`,
			method: "POST",
			body: { engagementDate, originalEngagement },
		})
			.then(({ data }) => {
				if (!notification) {
					dispatch(updatedEngagementDate(data));
					dispatch(getEmployeeDetails(agreementId));
				}
				NotificationManager.success("Engagement Date Updated Successfully!", "Engagement Date");
			})
			.catch((err) => {
				console.error(err);
				NotificationManager.error("Error Updating Engagement Date", "Engagement Date");
			});
	};
};

const setTerminationDate = (terminationDate, params) => {
	return async (dispatch, getState) => {
		const { agreement, notification } = { ...params };

		if (!notification) dispatch(savingTerminationDate(true));

		const state = getState();

		const agreementId = agreement ? agreement : state.employee.employeeDetails.id;

		await agreementRequest({
			path: `/${agreementId}/termination`,
			method: "POST",
			body: { terminationDate },
		})
			.then(({ data }) => {
				if (!notification) {
					dispatch(terminationDateSet(data));
					dispatch(getEmployeeDetails(agreementId));
				}
				NotificationManager.success("Termination Date Set Successfully!", "Termination Date");
			})
			.catch((err) => {
				console.error(err);
				NotificationManager.error("Error Setting Termination Date", "Termination Date");
				dispatch(savingTerminationDate());
			});
	};
};

const setRole = (roleID) => ({
	type: Types.EMPLOYEE_SET_ROLE,
	roleID,
});
const setDepartment = (departmentID) => ({
	type: Types.EMPLOYEE_SET_DEPARTMENT,
	departmentID,
});

const setSalary = (salaryId) => ({
	type: Types.EMPLOYEE_SET_SALARY,
	salaryId,
});

const setTax = (taxId) => ({
	type: Types.EMPLOYEE_SET_TAX,
	taxId,
});

const savingTerminationDate = (status) => ({
	type: Types.EMPLOYEE_SAVING_TERMINATION_DATE,
	status,
});

const terminationDateSet = (response) => ({
	type: Types.EMPLOYEE_SET_TERMINATION_DATE,
	payload: response,
});

// Redux Action for Single Employee
const engagementDateModal = (status) => ({
	type: Types.EMPLOYEE_ENGAGEMENT_DATE_MODAL,
	status,
});

// Redux Action for Single Employee
const terminationDateModal = (status) => ({
	type: Types.EMPLOYEE_TERMINATION_DATE_MODAL,
	status,
});

// Redux Action for Single Employee
const employeeTab = (tab) => ({
	type: Types.EMPLOYEE_TAB,
	tab,
});

// Redux Action for Single Employee
const confirmModal = ({
	input,
	status,
	formType,
	previousDate,
	minDate,
	maxDate,
	fixedDate,
	cannotReplace,
	cannotCreateNew,
	dateType = "date",
}) => ({
	type: Types.EMPLOYEE_CONFIRM_CHANGE_MODAL,
	input,
	status,
	formType,
	previousDate,
	minDate,
	maxDate,
	fixedDate,
	cannotReplace,
	cannotCreateNew,
	dateType,
});

const uploadingEmployees = (progress) => ({
	type: Types.EMPLOYEES_UPLOADING,
	progress,
});

const employeesUploaded = (payload) => ({
	type: Types.EMPLOYEES_UPLOADED,
	payload,
});
const previousEarningsUploading = (payload) => ({
	type: Types.EMPLOYEE_PE_UPLOADING,
	payload,
});
const previousEarningsUploaded = (payload) => ({
	type: Types.EMPLOYEE_PE_UPLOADED,
	payload,
});

const employeeImportTypes = {
	"Excel Import": "EMPLOYEE_IMPORT_EXCEL",
	"Generic Import": "EMPLOYEE_IMPORT_GENERIC",
	"FPS XML Upload": "EMPLOYEE_IMPORT_FPS",
};

const processingImport = (status) => ({
	type: Types.EMPLOYEES_PROCESSING_IMPORT,
	status,
});

const mapEmployeeUpload = (input) => {
	return async (dispatch, getState) => {
		const state = getState();

		const filesUploaded = state.employees.filesUploaded;

		// if (importType) modalStatus = "Generic Import";

		await request({
			method: "POST",
			path: "upload/employees/map",
			body: {
				key: filesUploaded[filesUploaded.length - 1].key,
				importType: input.importType,
			},
		})
			.then((res) => {
				dispatch(employeeFieldMapping(res.data));
			})
			.catch((err) => console.error(err));
	};
};

const employeeUpdateFieldMapping = (input) => {
	return async (dispatch, getState) => {
		dispatch(employeeUpdateFieldMappingResult(input));

		if (!input.value) {
			// if this is set to null there is no need to check from server
			return;
		}

		const state = getState();

		const filesUploaded = state.employees.filesUploaded;

		// if (importType) modalStatus = "Generic Import";

		await request({
			method: "POST",
			path: "upload/employees/map",
			body: {
				key: filesUploaded[filesUploaded.length - 1].key,
				preSetHeaders: {
					[input.header]: input.value,
				},
				importType: input.importType,
			},
		})
			.then((res) => {
				console.log("result", res.data.headers);
				res.data.headers.map((header) => {
					const innerMapping = res.data.innerMapping[header.header];

					dispatch(
						employeeUpdateFieldMappingResult({
							header: header.header,
							response: header,
							innerMapping,
						}),
					);
				});
			})
			.catch((err) => console.error(err));
	};
};

const uploadEmployees = ({ file, replaceExisting, importType }) => {
	return async (dispatch, getState) => {
		const state = getState();

		const filesUploaded = state.employees.filesUploaded;

		let modalStatus = state.employees.importModal;

		if (importType) modalStatus = "Generic Import";

		const employeeImportType = employeeImportTypes[modalStatus];

		if (!employeeImportType) {
			NotificationManager.error(`${modalStatus} is not supported`, "Upload Employees");
			return;
		}

		dispatch(processingImport(true));

		const body = {
			replaceExisting,
			key: filesUploaded[filesUploaded.length - 1].key,
			importType,
		};

		if (["Other", "PayItems", "TotalsToDate"].includes(importType)) {
			body.mapping = state.employees.uploadMapping.headers;
			body.innerMapping = state.employees.uploadMapping.innerMapping;
			body.defaultValues = state.employees.uploadMapping.default;
		}

		await request({
			method: "POST",
			path: `sf/${employeeImportType}`,
			body,
		})
			.then(async ({ data }) => {
				await checkExecutionStatus(data.executionArn)
					.then(({ output }) => {
						dispatch(
							employeesUploaded({
								processed: output.processed,
								errors: output.errors,
								warnings: output.warnings,
							}),
						);
					})
					.catch((err) => {
						console.error(err);
						NotificationManager.error("Error Uploading Employees", "Upload Employees");
					});
				dispatch(processingImport(false));
			})
			.catch((err) => {
				console.error(err);
				NotificationManager.error("Error Uploading Employees", "Upload Employees");
				dispatch(processingImport(false));
			});
	};
};
const uploadPreviousEarnings = ({ file, replaceExisting }) => {
	return (dispatch, getState) => {
		const state = getState();

		dispatch(previousEarningsUploading("0%"));

		const filesUploaded = state.employees.filesUploaded;

		axios
			.post(
				apiURL + `/settings/upload/previousEarnings`,
				{
					replaceExisting,
					key: filesUploaded[filesUploaded.length - 1].key,
					agreementID: state.employee?.agreementInfo?.id,
				},
				{
					withCredentials: true,
					onUploadProgress: (ProgressEvent) => {
						let progress = Math.round((ProgressEvent.loaded / ProgressEvent.total) * 100) + "%";

						dispatch(previousEarningsUploading(progress));
					},
				},
			)
			.then(({ data }) => {
				const { errors, missingFields, erroneousFields, saved } = data;

				dispatch(previousEarningsUploaded({ errors, missingFields, erroneousFields, saved }));
			})
			.catch((err) => console.error(err));
	};
};

const toggleImportModal = (status) => ({
	type: Types.EMPLOYEES_IMPORT_MODAL,
	status,
});

const clearImportResults = () => ({
	type: Types.EMPLOYEES_CLEAR_IMPORT_RESULTS,
});

const togglePEImportModal = (status) => ({
	type: Types.EMPLOYEES_IMPORT_PE_MODAL,
	status,
});

const employeeTemplateDownloaded = (template) => ({
	type: Types.EMPLOYEES_UPLOAD_TEMPLATE,
	template,
});

const employeeFieldMapping = (template) => ({
	type: Types.EMPLOYEES_FIELD_MAPPING,
	...template,
});

const employeeUpdateFieldMappingResult = (template) => ({
	type: Types.EMPLOYEES_FIELD_UPDATE_MAPPING,
	...template,
});

const employeeUpdateMappingDefaultValue = (template) => ({
	type: Types.EMPLOYEES_FIELD_UPDATE_DEFAULT_MAPPING,
	...template,
});

const employeeUpdateInnerMapping = (template) => ({
	type: Types.EMPLOYEES_FIELD_UPDATE_INNER_MAPPING,
	...template,
});

const getPreviousEarningsTemplate = ({ includeAllFields }) => {
	return (dispatch, getState) => {
		const state = getState();

		axios({
			url:
				apiURL +
				`/settings/upload/previousEarnings${constructQueryParams({
					agreementID: state.employee?.agreementInfo?.id,
					includeAllFields,
				})}`,
			method: "GET",
			withCredentials: true,
		})
			.then(({ data }) => {
				window.open(data.template, "_blank");
			})
			.catch((err) => console.error(err));
	};
};

const getEmployeeTemplate = () => {
	return async (dispatch, getState) => {
		const state = getState();

		await request({
			method: "GET",
			path: "upload/employees",
		})
			.then((res) => {
				dispatch(employeeTemplateDownloaded(res.data.template));
			})
			.catch((err) => console.error(err));
	};
};

const setFileUploading = (file) => ({
	type: Types.EMPLOYEES_FILE_UPLOADING,
	file,
});

const setFileUploaded = (file, key) => ({
	type: Types.EMPLOYEES_FILE_UPLOADED,
	file,
	key,
});

const uploadFile = ({ file }) => {
	return (dispatch, getState) => {
		const state = getState();

		const path = "/settings/upload";

		// NotificationManager.success('Your File is being uploaded','Info')
		dispatch(setFileUploading(file.name));

		fetch(apiURL + path, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify({
				name: file.name,
				type: file.type,
			}),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				const fileKey = data.key;

				// step 1 upload to AWS
				fetch(data.url, {
					credentials: "include",
					method: "PUT",
					body: file,
					headers: {
						"Accept": "application/json",
						"Content-Type": file.type,
					},
				}).then((data) => {
					dispatch(setFileUploaded(file.name, fileKey));
				});
			});
	};
};

const resetEmployeeMFA = () => ({
	type: Types.EMPLOYEE_RESET_MFA,
});

const resetMFA = (agreement) => {
	return (dispatch, getState) => {
		fetch(apiURL + `/settings/agreement/${agreement}/mfa`, {
			credentials: "include",
			method: "DELETE",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				NotificationManager.success("Employee MFA reset successfully!", "Resetting Employee MFA");
				dispatch(resetEmployeeMFA());
				dispatch(mfaStatusModal());
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("There was an error resetting MFA", "Resetting Employee MFA");
			});
	};
};

const rehireEmployee = (agreement) => {
	return async (dispatch, getState) => {
		const response = await fetch(apiURL + `/settings/agreement/${agreement}`, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(
					setNewEmployeeModal(true, undefined, {
						agreementInfo: {
							employeeDetails: data?.agreementInfo?.employeeDetails,
						},
					}),
				);
			});
	};
};

const terminateOccupationModal = (status, occupation) => {
	return (dispatch, getState) => {
		dispatch(deleteDetailsModal({ status, tab: "occupation", action: "terminate", item: occupation }));
	};
};

const setBulkChangesModal = (isOpen) => ({
	type: Types.EMPLOYEE_SET_BULK_CHANGES_MODAL,
	isOpen,
});

const employeeSaveFilters = (filters, changes) => ({
	type: Types.EMPLOYEE_SAVE_FILTERS,
	filters,
	changes,
});

const Actions = {
	rehireEmployee,
	employeesGetList,
	employeesGetListWithSalary,
	employeesUpdateListWithSalary,
	getTerminatedEmployees,
	showInviteEmployeeModal,
	sendInvites,
	sendInvite,
	toggleImportModal,
	getEmployeeTemplate,
	uploadEmployees,
	uploadFile,
	deleteAgreementData,
	setSalary,
	setTax,
	deleteTaxModal,
	deleteTaxSetting,
	employeeTab,
	getEmployeeDetails,
	saveEmployeeDetails,
	confirmModal,
	confirmChange,
	saveBankDetails,
	updateRole,
	setPayByBank,
	getTaxOptions,
	engagementDateModal,
	terminationDateModal,
	updateEngagementDate,
	setTerminationDate,
	getEmployeeAuditLogs,
	getEmployeeNotes,
	confirmGrade,
	setNewEmployeeModal,
	savePreviousEarnings,
	createNewEmployee,
	deleteSalaryModal,
	deleteSalary,
	updateSalary,
	updatePreviousEarnings,
	updateTaxDetails,
	updateEmployee,
	showCOLAModal,
	setEmployeeCOLA,
	setEmployeeCarryover,
	validateCarryover,
	saveCarryover,
	applyCola,
	setColaRounding,
	setColaPreApplied,
	carryoverBeingApplied,
	carryoverAppliedResult,
	removeGradeLock,
	setEmployeeDetails,
	updatedEmployee,
	newEmployeeUpdatedSalary,
	deleteAgreementModal,
	clearEmployee,
	mfaStatusModal,
	resetMFA,
	getCola,
	setColaFirstInPeriod,
	reviewEmploymentRole,
	togglePaymentHistoryModal,
	toggleAttachmentEarningsModal,
	getLongTermAdjustments,
	saveLongTermAdjustments,
	getChildren,
	toggleChildrenModal,
	saveChild,
	toggleChildLeaveModal,
	saveLongTermAdjustments,
	getPensionEnrolment,
	getAutoEnrolment,
	getPreviousEarningsTemplate,
	togglePEImportModal,
	uploadPreviousEarnings,
	setRole,
	deleteRoleModal,
	deleteDepartmentModal,
	setDepartment,
	updateDepartmentModal,
	updateDetailsModal,
	updateDetails,
	deleteDetailsModal,
	deleteEmployeeDetails,
	saveAgreementPension,
	putAgreementPension,
	updatePostponeDateModal,
	deletePension,
	deletePensionModal,
	calculateChangeImpact,
	setBulkChangesModal,
	getTotalsToDate,
	clearImportResults,
	employeeSaveFilters,
	newOccupationModal,
	terminateOccupationModal,
	mapEmployeeUpload,
	employeeFieldMapping,
	employeeUpdateFieldMapping,
	employeeUpdateInnerMapping,
	employeeUpdateMappingDefaultValue,
};
export { Actions, Types };
